import * as types from "../../store/types/types";
import "./index.scss";
import DSBPScreenList from "./DSBPScreenList";
import PageLayout from "../PageLayout";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { isRoleMatch } from "../../utils";
import LoadingOverlay from "react-loading-overlay-ts";
import UnAuthorizedComponent from "../UnAuthorized/UnAuthorizedComponent";
import { getDSBPScreenData } from "../../store/actions/DSBPScreenActions";
import { useUnsavedChangesWarning } from "../common/NavigationPrompt";
import { getBuRegionList, getValidBUList } from "../../service/DashboardService";
import { AcpService } from "../../service/ACPService";

const AddToProjectPopUp = React.lazy(() => import("./AddToProjectPopUp"));

const DSBPWrapper = () => {
  const [isRouterReady, setIsRouterReady] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRouterReady(true);
    });
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!isRouterReady) {
    return <div>Loading...</div>;
  }
  
  return <DSBPScreen />;
};

const DSBPScreen = () => {
  const User = useSelector((state) => state?.UserReducer);
  const {
    selectedBU,
    selectedDropdownValue,
    userDetails: { AccessGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const userInformation = User?.userInformation;
  const dispatch = useDispatch();
  const [addToProjectPopUpStatus, setAddToProjectPopUpStatus] = useState(false);
  const [initiativeId, setInitiativeId] = useState("");
  const [initiativeName, setInitiativeName] = useState("");
  const [allocation, setAllocation] = useState(false);
  const [buRegionList, setBuRegionList] = useState([]);
  const [validBu, setValidBu] = useState([]);
  const [buRegionValue, setBuRegionValue] = useState(
    !AcpService.isUBN(selectedDropdownValue) && Object.keys(selectedDropdownValue)?.length
      ? selectedDropdownValue
      : ""
  );
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const user_group = useSelector((state) => state?.UserDetailsReducer?.userDetails?.UserGroup);
  const DSBPScreenLoader = useSelector((state) => state.DSBPScreenReducer.loading);
  
  const [checkReadWriteAccess, setUserAccess] = useState(false);
  const [xregionValue, setXregionValue] = useState("");

  useEffect(()=>{
    markClean();
    // writing this line because on loading the pages we need to clear unsaveChanges localstorage
  },[])

  useEffect(() => {
    if (user_group?.length) {
      const validBUList = getValidBUList(user_group, true);
      setValidBu(validBUList);
      const burRegionData = getBuRegionList(user_group, true);
      setBuRegionList(burRegionData);
    }
  }, [user_group]);

  useEffect(() => {
    dispatch({
      type: types.GET_DSBP_DETAILS_REQUEST,
    });
    const budetails = selectedBU?.length ? selectedBU : validBu;
    setXregionValue(budetails[0]?.UserRegion[0]?.Region_Name);
    //load the api only when user has access as per 3109 security matrix
    if (
      (user_group?.length > 1 &&
        userInformation?.userid &&
        checkReadWriteAccess &&
        buRegionValue &&
        selectedBU) ||
      (user_group?.length === 1 && userInformation?.userid && checkReadWriteAccess)
    ) {
      dispatch(
        getDSBPScreenData(
          budetails[0].UserBU[0].BU_Name,
          budetails[0].UserRegion[0].Region_Name,
          allocation
        )
      );
    } else {
      dispatch({
        type: types.GET_ALL_DSBP_SCREEN_DATA_ERROR,
        payload: "Data not found",
      });
    }
  }, [
    user_group?.length,
    userInformation?.userid,
    checkReadWriteAccess,
    selectedBU,
    allocation,
  ]);

  useEffect(() => {
    const isUserAccess = isRoleMatch(AccessGroup, ["ProjectManager"]);
    setUserAccess(isUserAccess);
  }, [AccessGroup]);

  const cancelPopUp = () => setAddToProjectPopUpStatus(false)

  return (
    <>
      <PageLayout>
        <div className="content-layout" id="tableDiv">
          <div className="tabular-view">
            <LoadingOverlay active={DSBPScreenLoader} spinner text="">
              {checkReadWriteAccess ? (
                <DSBPScreenList
                  buRegionList={buRegionList}
                  validBu={validBu}
                  buRegionValue={buRegionValue}
                  setBuRegionValue={setBuRegionValue}
                  allocation={allocation}
                  setAllocation={setAllocation}
                  header="DSBP"
                  setAddToProjectPopUpStatus={setAddToProjectPopUpStatus}
                  setInitiativeId={setInitiativeId}
                  setInitiativeName={setInitiativeName}
                  xregionValue={xregionValue}
                />
              ) : (
                AccessGroup && AccessGroup.length && <UnAuthorizedComponent nowrapper={true} />
              )}
            </LoadingOverlay>
          </div>
        </div>
        <AddToProjectPopUp
          visible={addToProjectPopUpStatus}
          selectedBU={selectedBU.length ? selectedBU : validBu}
          allocation={allocation}
          onCancel={cancelPopUp}
          initiativeId={initiativeId}
          initiativeName={initiativeName}
        />
      </PageLayout>
    </>
  );
};

export default DSBPWrapper;